import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page2',
  templateUrl: './page2.component.html',
  styleUrls: ['./page2.component.css']
})
export class Page2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
    function isMobile() {
      if (sessionStorage.desktop)
          return false;
      else if (localStorage.mobile)
          return true;
      var mobile = ['iphone', 'ipad', 'android', 'blackberry', 'nokia', 'opera mini', 'windows mobile', 'windows phone', 'iemobile'];
      for (var i in mobile)
          if (navigator.userAgent.toLowerCase().indexOf(mobile[i].toLowerCase()) > 0) return true;
      return false;
  }

/* 
    var sendbtn = document.querySelector('#sendbtn');
    sendbtn.addEventListener('click', enviarMensaje) */
    const formulario = document.getElementById('formulario');
    const buttonSubmit = document.getElementById('sendbtn');
 
    const urlDesktop = 'https://web.whatsapp.com/';
    const urlMobile = 'whatsapp://';
    const telefono = '522381459899';
    
    formulario.addEventListener('submit', (event) => {
        event.preventDefault()
        buttonSubmit.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
        
        setTimeout(() => {
            let inputName = (<HTMLInputElement>document.getElementById('formGroupExampleInput')).value;
            let textareame = (<HTMLInputElement>document.getElementById('exampleFormControlTextarea1')).value;
            let domicilio = (<HTMLInputElement>document.getElementById('domicilioText')).value;
            let mensaje = 'send?phone=' + telefono + '&text=%0A*Nombre:%0A' + inputName + '%0A*Domicilio:%0A' + domicilio + '%0A*Pedido:%0A' +  textareame + ''
            if(isMobile()) {
                window.open(urlMobile + mensaje, '_blank')
            }else{
                window.open(urlDesktop + mensaje, '_blank')
            }
            buttonSubmit.innerHTML = '<i class="fab fa-whatsapp"></i> Enviar WhatsApp'
            
        }, 3000);
    });


  /*   function enviarMensaje() {
      let inputName = document.querySelector('#formGroupExampleInput').value
      let textareame = (document.querySelector('#exampleFormControlTextarea1') as HTMLTextAreaElement).value;
      let domicilio = (document.querySelector('#domicilioText') as HTMLTextAreaElement).value;
      let url = "https://api.whatsapp.com/send?phone=522381733121&text=Nombre: %0A" + inputName + "%0A%0ADomicilio: %0A" + domicilio + "%0A%0AOrden: %0A" + textareame + "%0A";
      window.open(url);


    } */
  }
  
}